"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("../Text/constant");
var _constant3 = require("../Link/constant");
var _default = exports.default = {
  PropTypes: {
    theme: _propTypes.default.oneOf(_constant.Themes),
    accessible: _propTypes.default.bool,
    couponCode: _propTypes.default.string.isRequired,
    labelText: _propTypes.default.string,
    labelColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    labelSize: _propTypes.default.oneOf(_constant2.ARR_TEXT_TYPE),
    couponTextColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    couponTextSize: _propTypes.default.oneOf(_constant2.ARR_TEXT_TYPE),
    ctaLinkText: _propTypes.default.string,
    ctaLinkColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    ctaLinkUnderlined: _propTypes.default.bool,
    ctaLinkHoverColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    ctaLinkHoverUnderlined: _propTypes.default.bool,
    ctaLinkCallback: _propTypes.default.func,
    updateGtmId: _propTypes.default.func,
    ctaLinkHref: _propTypes.default.string,
    ctaLinkTarget: _propTypes.default.oneOf(Object.keys(_constant3.LINK_TARGET))
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    labelText: 'Coupon Code',
    labelColor: 'greyMedium',
    labelSize: 'sub',
    couponTextColor: 'neutral',
    couponTextSize: 'default',
    ctaLinkText: 'Copy',
    ctaLinkColor: 'secondary',
    ctaLinkUnderlined: false,
    ctaLinkHoverColor: 'secondary',
    ctaLinkHoverUnderlined: true,
    ctaLinkTarget: 'tab'
  }
};